type LoginButtonProps = { onClick: () => void }

export default function LoginButton(props: LoginButtonProps) {
  return (
    <button className="mt-4 btn-primary" onClick={props.onClick}>
      Logg inn
    </button>
  )
}
